export default {
    // API_BASE_URL: "http://localhost:9000/graphql",
    API_BASE_URL: "https://api-dev.dh-thailand.com/graphql",
};
